import {SignUpComponent} from "../SignUpComponent.js";


export class Layout extends SignUpComponent {

    template() {
        const {sectionId = ''} = this.$props;
        return `
                <section id="${sectionId}" class="signup-wide-pop">
                    <header class="js-section-header"></header>
                    <article>
                        <div class="pop-main js-contents-main">
                            ${this.getMainTextTemplate()}
                            ${this.getSubTextTemplate()}
                            ${this.getNexPageButtonTemplate()}
                        </div>
                    </article>
                </section>`
    }

    getMainTextTemplate() {
        const {mainText = ''} = this.$props;
        return  !Mutil.empty(mainText) ?  `<h3 id="mainTxt">${mainText}</h3>` : "";
    }

    getSubTextTemplate() {
        const { subText = ''} = this.$props;
        return  !Mutil.empty(subText) ?  `<p id="subTxt">${subText}</p>` : "";
    }

    getNexPageButtonTemplate() {
        const {nextButton = {}} = this.$props;
        return  Object.values(nextButton).length > 0  ?  `<button id = "${nextButton.id}" class="js-next-page-button" >${Mutil.n2v(nextButton.text)}</button>` : "";
    }

    getNextLinkTemplate() {
        const {nextLink = {}} = this.$props;
        return  Object.values(nextLink).length > 0  ?  `<a id = "${Mutil.n2v(nextLink.id)}" class="js-next-page-link" >${Mutil.n2v(nextLink.text)}</a>` : "";
    }

    setEvent() {
        this.setNextPageButtonEvent();
        this.setNextPageLinkEvent();
    }

    setNextPageLinkEvent() {
        const {nextLink = {}} = this.$props;
        if (Object.values(nextLink).length === 0) {
            return;
        }
        const {
            nextPageFunc = Mutil.noop
        } = nextLink;
        this.addEvent("click.prevent", ".js-next-page-link", () => {
            nextPageFunc();
        });
    }

    setNextPageButtonEvent() {
        const {nextButton = {}} = this.$props;
        if (Object.values(nextButton).length === 0) {
            return;
        }

        const {
            nextPageFunc = Mutil.noop
        } = nextButton;

        const _nextPageFunc = new Mutil.DebounceNThrottle(() => {
            nextPageFunc()
        }, 300);
        this.addEvent("click", '.js-next-page-button', (e) => {
            _nextPageFunc.debounceAfterStart();
        });
    }

    getHeaderSelector() {
        return ".js-section-header"
    }

    getHeaderLayer() {
        const selectionSelector = this.getSelectionSelector();
        return $(selectionSelector).find(`${this.getHeaderSelector()}`)
    }

    getSelectionSelector() {
        const {sectionId = ''} = this.$props;
        return Mutil.empty(sectionId) ? "section" : `#${sectionId}`;
    }

    getMainArticle() {
        const selectionSelector = this.getSelectionSelector();
        return $(selectionSelector).find(`article`);
    }
}